<template>
    <div class="blackBg animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">俱乐部介绍</span>
        </div>

        <div class="cardBg">
            <p>
                北京控股篮球俱乐部前身为重庆翱龙篮球俱乐部，于2014年球队通过准入制升入CBA联赛。
                2015年，北 京控股集团完成了对重庆男篮的收购，球队正式更名为北京控股篮球俱乐部。
                北控篮球俱乐部于2019-2020赛季全面重建，迎来全新的管理层团队及一线队阵容。
                在重建的三个赛季 以来，在北控集团党委的领导下，凭借清晰的战略规划和布局，北控篮球俱乐部致力于培养年轻球员，建立纪 律严明、奋勇争先、具有优秀体育道德风尚和战斗力的一流队伍，打造了拥有全新风貌的一线队和青年体系。
                通过不断的探索与实践，北控篮球俱乐部已经成为京城篮球版图中不可或缺的重要组成。
                北控篮球俱乐部也将 不断提升自我，不断前行，为中国及京城篮球的发展、为丰富人民群众的文化体育生活做出应有的贡献。
            </p>

            <div class="list">
                <dl>
                    <dt @click="goPage({
                     path: '/about/moment',
                        name: 'moment',
                        goType: 1
                    })">精彩瞬间
                        <Icon type="ios-arrow-dropright"/>
                    </dt>
                    <dd>
                        <carousel :interval="3000" :arrow="'never'" height="16vw" :indicator-position="'none'">
                            <carousel-item v-for="i in imgList.length">
                                <img style="width: 100%" :src="imgList[i-1]" alt="">
                            </carousel-item>
                        </carousel>
                    </dd>
                </dl>
                <dl>
                    <dt @click="goPage({ path: '/about/videoClipList',
                        name: 'videoClipList',
                        query: {
                            type: 1, //传参--是俱乐部精彩视频
                        },
                        goType: 1})">视频资料
                        <Icon type="ios-arrow-dropright"/>
                    </dt>
                    <dd><img src="../assets/img/demoImg/test2.png" alt=""></dd>
                </dl>
            </div>
            <div style="clear: both"></div>

        </div>
    </div>
</template>

<script>
export default {
    name: "introduce",
    computed: {
        paramsCommandFn() {
            return this.$store.state.lookCommand;
        }
    },
    data() {
        return {
            imgList: [
                require('@/assets/img/moment/1.png'),
                require('@/assets/img/moment/2.png')
            ]
        }
    },
    watch: {
        paramsCommandFn: {
            handler(val, old) {
                let routerObj = {};
                let flag = false;
                if (eval('/精彩瞬间/gi').test(val)) {
                    routerObj = {
                        path: '/about/moment',
                        name: 'moment',
                        goType: 1
                    }
                    flag = true;
                } else if (eval('/视频资料/gi').test(val)) {
                    routerObj = {
                        path: '/about/videoClipList',
                        name: 'videoClipList',
                        query: {
                            type: 1, //传参--是俱乐部精彩视频
                        },
                        goType: 1
                    }
                    flag = true;
                }

                if (flag) {
                    this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息
                    this.$store.dispatch("setRouter", routerObj);//vuex改变路由
                } else {
                    this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息
                }
            },
            deep: true
        },
    },
    mounted() {
        this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('这是俱乐部介绍'), true, true, 1);
    },
    methods: {
        goPage(item) {
            this.$store.dispatch("setRouter", item);//vuex改变路由
            this.$router.push(item)
        }
    }
}
</script>

<style scoped lang="less">
.cardTit {
    background-image: url("../assets/img/updateImg/head_2.png");
    position: relative;
    font-size: 30px;
}

.cardBg {
    padding: 2vw;
    min-height: calc(100% - 140px);
    box-sizing: border-box;

    p {
        font-family: PingFang;
        font-size: 22px;
        color: rgba(255, 255, 255, .8);
        line-height: 2vw;
        text-indent: 50px;
        letter-spacing: 2px
    }

    .list {
        margin-top: 2vw;

        dl {
            text-align: center;
            font-family: PingFang;
            font-size: 24px;
            color: rgba(255, 255, 255, .8);
            width: 48%;

            &:first-child {
                float: left;
            }

            &:last-child {
                float: right;
            }

            dt {
                height: 3vw;
                line-height: 3vw;
                background-color: rgba(216, 216, 216, .1);
                font-family: PingFangMedium;

                i {
                    font-size: 30px;
                }
            }
        }

        img {
            width: 100%;
        }
    }
}
</style>
